import { Box, Text, TextButton } from '@wix/design-system';
import React from 'react';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import s from '../whoisResultsPage.scss';
const ICANN_COMPLAINT_URL = 'https://www.icann.org/compliance/complaint';
export const RawOnlySection = _ref => {
  let raw = _ref.raw;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    Trans = _DomainSearchGateModu.Trans;
  const text = raw.registrar ?? raw.registry;
  if (!text) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true,
    className: s.rawDataText
  }, text), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_gate.whois_results.accordion.terms_of_service.inaccuracy_complaint",
    components: [/*#__PURE__*/React.createElement(TextButton, {
      key: "icann",
      as: "a",
      size: "small",
      underline: "always",
      className: s.accordionInlineLink,
      href: ICANN_COMPLAINT_URL,
      target: "_blank",
      rel: "noopener noreferrer",
      style: {
        color: 'inherit'
      }
    })]
  })));
};
//# sourceMappingURL=RawOnlySection.js.map